/* eslint-disable */
export const MEMORY_CONFIG = {
  // Population limits
  maxGlobalChocobos: 300,          // Maximum total chocobos in the game
  maxPlayerChocobos: 15,           // Maximum chocobos a player can own
  maxNPCChocobos: 8,               // Maximum chocobos an NPC can own
  
  // Retirement thresholds
  retirementAgeYears: 3,           // Chocobos retire after 3 game years
  minRetirementLevel: 30,          // Minimum level before forced retirement at age 2
  
  // Race history limits
  maxRaceHistoryPerChocobo: 20,    // Keep only last 20 races per chocobo
  maxDetailedRaceHistory: 10,      // Keep full details for last 10 races
  
  // Background racing
  backgroundRacesPerDay: 50,       // Number of background races to simulate daily
  virtualRacePoolSize: 100,        // Pre-calculated race results pool
  
  // Monthly race tier limits (to control economy)
  monthlyRaceLimits: {
    saucer: 1,           // 1 Gold Saucer race per month
    global: 2,           // 2 Global races per month  
    transcontinental: 3, // 3 Trans-Continental races per month
    continental: 8,      // 8 Continental races per month
    regional: 36         // Remaining races are Regional (low reward)
  },
  
  // Memory management thresholds
  memoryWarningThreshold: 80,      // MB - Show warning at this memory usage
  compressionThreshold: 60,        // MB - Start compression at this threshold
  criticalThreshold: 100,          // MB - Force aggressive cleanup
  
  // Historical data settings
  archiveThresholdDays: 90,        // Archive races older than 90 days
  leaderboardSize: 10,             // Number of entries in leaderboards
  historicalTrendMonths: 12,       // Months of trend data to keep
  
  // Transaction and auction limits
  maxTransactionHistory: 20,       // Keep last 20 transactions
  maxActiveAuctions: 10,           // Maximum concurrent auctions
  
  // Cleanup intervals
  cleanupIntervalDays: 32,         // Run cleanup every game month
  populationCheckInterval: 7,      // Check population caps weekly
  
  // Performance settings
  enableBackgroundCompression: true,
  enableLazyLoading: true,
  enableVirtualRacing: true
}

// Development/Debug settings
export const DEBUG_CONFIG = {
  showMemoryStats: false,          // Display memory usage in UI
  logRetirements: true,            // Log retirement events
  logPopulationChanges: true,      // Log population cap enforcements
  preventPlayerRetirement: true    // Prevent automatic player chocobo retirement
}